import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import Slider from 'Components/UI/Slider';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = theme => ({
  root: {
    width: '100%',
    paddingTop: theme.spacing(6),
  },
});

const SliderQuestion = ({
  onChange,
  options,
  value,
  className,
  classes,
  ...rest
}) => {
  const marks = options.map((option, i) => {
    return {
      value: i + 1,
      label: option.prompt,
      id: option.id,
    };
  });

  const sliderValue = (value.length === 0) ? Math.ceil(options.length / 2) : marks.filter(v => v.id === value[0])[0].value;

  const handleChange = (newValue) => {
    const numberNewValue = Number(newValue);
    onChange([marks[numberNewValue - 1].id]);
  };

  return (
    <Slider
      className={classNames(classes.root, className)}
      visibleLabelDisplay
      visibleMarks
      marks={marks}
      color="primary"
      value={sliderValue}
      onChange={handleChange}
      {...rest}
    />
  );
};
SliderQuestion.defaultProps = {
  className: '',
};
SliderQuestion.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.object.isRequired,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SliderQuestion);
